function loop(theme, res, list, type) {
  const suffixes = {
    main: '',
    light: 'light',
    ultralight: 'ultralight',
    dark: 'dark',
    ultradark: 'ultradark',
    sky: 'sky',
  };
  const suffixe = suffixes[type];
  list.forEach(key => {
    res[`${key}${suffixe}`] = {
      backgroundColor: theme.palette[key][type],
      color: theme.palette[key].contrastText,
    };
  });
}

export default theme => {
  const main = [
    'white',
    'black',
    'grey',
    'blue',
    'brown',
    'green',
    'khaki',
    'orange',
    'pink',
    'purple',
    'red',
    'teal',
    'yellow',
  ];
  const light = ['grey', 'red', 'green', 'blue', 'orange', 'purple', 'teal', 'yellow'];
  const ultralight = ['blue', 'green'];
  const dark = ['blue', 'green', 'khaki', 'pink', 'purple', 'red', 'teal'];
  const ultradark = ['red'];
  const sky = ['blue'];

  const res = {
    dialogPaper: {
      overflow: 'initial',
      backgroundColor: theme.palette.blue.main,
      color: theme.palette.white.main,
      padding: theme.spacing(5),
      '& .date': {
        fontSize: 'clamp(0.85rem, 0.17vw + 0.78rem, 1rem)',
      },
      '& > *': {
        position: 'relative',
      },
      '& .textToBeChanged': {
        color: theme.palette.red.main,
      },
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(3),
        margin: theme.spacing(3),
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1),
        margin: theme.spacing(1),
      },
    },
    closeIcon: {
      position: 'absolute',
      top: 0,
      right: 0,
      transform: 'translate(50%,-50%)',
      backgroundColor: theme.palette.black.main,
      [theme.breakpoints.down('sm')]: {
        height: 40,
        width: 40,
        '& svg': {
          height: 25,
          width: 25,
        },
      },
      [theme.breakpoints.down('xs')]: {
        height: 32,
        width: 32,
        minHeight: 32,
        right: theme.spacing(4),
        '& svg': {
          height: 20,
          width: 20,
        },
      },
    },
    dialogContent: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
      '& > *': {
        width: '100%',
      },
      '&.twoColumns > *': {
        '&:first-child': {
          paddingRight: theme.spacing(2),
          [theme.breakpoints.down('sm')]: {
            paddingRight: 0,
          },
        },
        '&:last-child': {
          paddingLeft: theme.spacing(5),
          [theme.breakpoints.down('sm')]: {
            paddingLeft: 0,
          },
        },
        '& > *': {
          paddingBottom: theme.spacing(2),
        },
      },
    },
    title: {
      fontFamily: '"Prata", sans-serif',
      fontWeight: 400,
      textTransform: 'none',
    },
    desc: {
      position: 'relative',
      paddingBottom: theme.spacing(1),
      '& .list': {
        display: 'block',
        margin: '1% 1%',
      },
    },
    link: {
      textDecoration: 'underline',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  };

  loop(theme, res, main, 'main');
  loop(theme, res, light, 'light');
  loop(theme, res, dark, 'dark');
  loop(theme, res, ultralight, 'ultralight');
  loop(theme, res, ultradark, 'ultradark');
  loop(theme, res, sky, 'sky');

  return res;
};
